import { SAVEPROFILEPIC, SAVEPROFILEPIC_ERROR, SAVEPROFILEPIC_HIDE_ERROR, SAVEPROFILEPIC_START_LOADER, SAVEPROFILEPIC_STOP_LOADER } from "../interface/IsaveProfilePic";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const SaveProfilePicReducer = (state = initState, action) => {
    switch (action.type) {
        case SAVEPROFILEPIC:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case SAVEPROFILEPIC_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case SAVEPROFILEPIC_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case SAVEPROFILEPIC_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case SAVEPROFILEPIC_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default SaveProfilePicReducer;
